<div class="eom">
  <!-- Header verde -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">tune</mat-icon>
      <h1 style="font-size: 1.25rem; font-weight: 700; color: #1e5a3f; margin: 0;">Actualizar Parámetros</h1>
    </div>
  </div>

  <div class="eom-cuerpo">
    <form *ngIf="form" [formGroup]="form">
      <!-- Selector de operador -->
      <div class="mb-4">
        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Operador</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">business</mat-icon>
          <mat-select formControlName="operador">
            <mat-option *ngFor="let op of operadores" [value]="op.value">
              {{ op.label }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('operador')?.invalid">
            {{ getErrorMessage('operador') }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Grid de campos -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Descuento Fiat</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">discount</mat-icon>
          <input matInput type="number" formControlName="descuentoFiat" step="0.0001"/>
          <mat-error *ngIf="form.get('descuentoFiat')?.invalid">
            {{ getErrorMessage('descuentoFiat') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Comisión CLP - VES (%)</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">percent</mat-icon>
          <input matInput type="number" formControlName="comision" step="0.1"/>
          <mat-error *ngIf="form.get('comision')?.invalid">
            {{ getErrorMessage('comision') }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Rate VES/USDT</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">swap_vert</mat-icon>
          <input matInput type="number" formControlName="rateVesUsdt" step="0.01"/>
          <mat-hint *ngIf="!isRateEditable" style="font-size: 0.7rem;">
            Automático para {{ form.get('operador')?.value }}
          </mat-hint>
          <mat-error *ngIf="form.get('rateVesUsdt')?.invalid">
            {{ getErrorMessage('rateVesUsdt') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>USD/CLP</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">attach_money</mat-icon>
          <input matInput type="number" formControlName="usdClp" step="0.01"/>
          <mat-error *ngIf="form.get('usdClp')?.invalid">
            {{ getErrorMessage('usdClp') }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Separador VES->CLP -->
      <hr style="border: none; border-top: 1px solid #d1d5db; margin: 12px 0 16px;">

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Comisión VES - CLP (%)</mat-label>
          <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">percent</mat-icon>
          <input matInput type="number" formControlName="comisionVesClp" step="0.1"/>
          <mat-error *ngIf="form.get('comisionVesClp')?.invalid">
            {{ getErrorMessage('comisionVesClp') }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Ganancia real VES->CLP (informativa): píldora, regla −1 % a +2 % y una sola recomendación -->
      <div *ngIf="gananciaVesClp as g" class="mb-4 ganancia" [ngClass]="'ganancia--' + g.nivel">
        <div class="ganancia-titulo">Ganancia real VES → CLP</div>
        <div class="ganancia-pildora" aria-live="polite">
          <span class="ganancia-cifra">{{ pct(g.gananciaPct) }}</span>
          <span class="ganancia-nivel">· {{ etiquetaNivel(g) }}</span>
        </div>

        <div class="regla" role="img" [attr.aria-label]="'Ganancia ' + pct(g.gananciaPct) + ' en una regla de −1 % a +2 %'">
          <div class="regla-barra"></div>
          <div class="regla-marcador" [style.left.%]="posicion(g)"></div>
          <span *ngFor="let m of marcasRegla" class="regla-marca" [style.left.%]="m.pos">{{ m.texto }}</span>
        </div>

        <div *ngIf="g.gananciaPct < gananciaSugeridaPct" class="ganancia-reco">
          Para ganar {{ gananciaSugeridaPct }} % sube «Comisión VES - CLP» a ≈
          <b>{{ numero(g.comisionParaSugerida) }}</b>.
        </div>

        <details class="ganancia-detalle">
          <summary>¿Cómo se calcula?</summary>
          <p>
            La comisión VES - CLP se suma a una tasa que ya descontó la comisión CLP - VES,
            por eso la ganancia es aprox. <b>VES-CLP − CLP-VES</b>. Se mide en la franja más grande;
            las menores suman sus descuentos encima.
          </p>
        </details>
      </div>

      <!-- Botones -->
      <div class="flex flex-col sm:flex-row gap-2 justify-center eom-botones">
        <button type="button" (click)="onCancel()"
          class="w-full sm:w-auto"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          Cancelar
        </button>
        <button type="button" (click)="onSave()"
          [disabled]="form.invalid"
          [style.opacity]="form.invalid ? '0.5' : '1'"
          [style.cursor]="form.invalid ? 'not-allowed' : 'pointer'"
          class="w-full sm:w-auto"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
          Guardar
        </button>
      </div>
    </form>
  </div>
</div>
